import {ACTION_TYPES} from 'Utils/constants';
import * as analytics from 'Utils/analytics';

const setTrackUserLocation = trackingUser => {
    if (trackingUser) analytics.sendGeolocateUserEvent();
    return {
        type: ACTION_TYPES.SET_DEVICE_DATA,
        data: {trackingUser},
    };
};
export default setTrackUserLocation;
